export default __webpack_public_path__ + "static/media/tutorBecome.6695883f.svg";